// Page-hero slider — crossfades between `.page-hero__slide` siblings
// inside any `[data-page-hero-slider]` element. Hand-rolled because the
// theme has no slider library and a hero crossfade only needs ~80 lines.
//
// Speed: read from `data-page-hero-slider-speed` (seconds, fallback 6).
// Reduced motion: visitors with `prefers-reduced-motion: reduce` see
// only the first slide; the rotation never starts and arrows / dots
// remain functional for manual navigation.

const DEFAULT_SPEED_SECONDS = 6;

function buildSlider(hero) {
    const slides = hero.querySelectorAll('.page-hero__slide');

    if (slides.length < 2) {
        return;
    }

    const arrows = hero.querySelectorAll('[data-page-hero-arrow]');
    const dots = hero.querySelectorAll('[data-page-hero-dot]');

    const speedSeconds = parseInt(hero.dataset.pageHeroSliderSpeed, 10);
    const intervalMs =
        (Number.isFinite(speedSeconds) && speedSeconds >= 3
            ? speedSeconds
            : DEFAULT_SPEED_SECONDS) * 1000;

    const reduceMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let activeIndex = 0;
    let timer = null;

    const goTo = (index) => {
        const next = ((index % slides.length) + slides.length) % slides.length;

        if (next === activeIndex) {
            return;
        }

        slides[activeIndex].classList.remove('is-active');
        slides[next].classList.add('is-active');

        if (dots.length) {
            dots[activeIndex].classList.remove('is-active');
            dots[activeIndex].setAttribute('aria-selected', 'false');
            dots[next].classList.add('is-active');
            dots[next].setAttribute('aria-selected', 'true');
        }

        activeIndex = next;
    };

    const startTimer = () => {
        if (reduceMotion || timer) {
            return;
        }

        timer = setInterval(() => goTo(activeIndex + 1), intervalMs);
    };

    const restartTimer = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }

        startTimer();
    };

    arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
            const direction = arrow.dataset.pageHeroArrow === 'prev' ? -1 : 1;
            goTo(activeIndex + direction);
            restartTimer();
        });
    });

    dots.forEach((dot) => {
        dot.addEventListener('click', () => {
            const target = parseInt(dot.dataset.pageHeroDot, 10);

            if (Number.isFinite(target)) {
                goTo(target);
                restartTimer();
            }
        });
    });

    startTimer();
}

export default function pageHeroSlider() {
    const heroes = document.querySelectorAll('[data-page-hero-slider]');
    heroes.forEach(buildSlider);
}
